import { ConfigModuleCategory } from 'library/ts/model/enums/config/ConfigModuleCategory';
import { IPalParams } from 'tag/ts/tag/interfaces/config/pal/IPalParams';

/**
 * @copyright © Paramount Streaming
 * @description Google PAL (Publisher Advertiser Link) plugin config for Pluto TV Blackbird.
 * Enabled by default for Stitcher playback — gated on `hasStitcherParams()` in `PalPlugin.shouldBeUsed()`.
 *
 * `playerVersion` is resolved at runtime from the Smart Tag release version if not set by the page.
 * `continuousPlayback` and `getPlayerSize` are resolved per stream in PalPlugin.getFactoryParams()
 * from stream type and player container dimensions; page-supplied values take precedence.
 *
 * Smart Tag invokes bootstrapBrowserPal() internally each time PalPlugin.shouldBeUsed() returns
 * true (idempotent + cached — repeated calls collapse to one SDK load); the tag consumer does
 * NOT need to load the PAL SDK or bootstrap the shim.
 *
 * @see {@link https://playback-docs.webctv.plutostaging.tv/docs/plugins/pal}
 */
export const TagConfigPal = {
	category: ConfigModuleCategory.PLUGIN,
	enabled: true,
	params: {
		enabled: true,
		playerType: 'plutotv', // IAB-registered PAL player name — confirmed by Khang Duong (Pluto TV Ads)
		playerVersion: null, // resolved at runtime from Smart Tag release version
		adWillAutoPlay: true, // confirmed by Hebert Morais (Blackbird) — matches Pluto TV legacy
		adWillPlayMuted: true, // confirmed by Hebert Morais (Blackbird) — matches Pluto TV legacy
		getDescriptionUrl: () => 'https://pluto.tv', // confirmed by Hebert Morais — googlePALNonceUrlOverride
		// Ceiling (not baseline) for the wait inside Blackbird's PAL plugin REQUEST hook.
		// Blackbird's `waitForNonce` resolves the moment the nonce is ready — the cap only
		// fires when the nonce takes longer than this value, in which case the manifest
		// request proceeds without `paln`. Typical sessions wait ~50–200ms; warm-SDK
		// subsequent nonces resolve <50ms. The 150ms default is too tight for cold-SDK
		// first-nonce generation (GAM round-trip), so we bump to 1500ms to capture `paln`
		// on the first manifest without affecting time-to-first-frame in normal cases.
		nonceTimeoutMs: 1500
	} as IPalParams
};